import type { LandingContent } from '../content';
import { Reveal } from '../components/Reveal';
import { SectionContainer } from '../components/SectionContainer';

type StorytellersSectionProps = {
  content: LandingContent['storytellers'];
};

export function StorytellersSection({ content }: StorytellersSectionProps) {
  return (
    <section className="bg-white py-24 text-[#1C1C1E]">
      <SectionContainer>
        <Reveal>
          <h2 className="font-pangaia text-[34px] font-bold leading-[1.1] sm:text-[44px]">
            {content.title}
          </h2>
        </Reveal>

        <div className="mt-10 flex gap-4 overflow-x-auto pb-2 no-scrollbar snap-x snap-mandatory">
          {content.reviews.map((review, index) => (
            <Reveal key={review.id} delay={index * 80} className="min-w-[320px] max-w-[360px] snap-start rounded-[24px] border border-[#E5E7F2] bg-[#F6F7FB] p-6 shadow-[0_18px_50px_rgba(24,28,38,0.06)]">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="font-pangram text-[12px] uppercase tracking-[0.16em] text-[#7B8091]">
                    {review.role}
                  </p>
                  <p className="mt-2 font-pangaia text-[24px] leading-[30px] text-[#1C1C1E]">
                    {review.author}
                  </p>
                </div>
                <div className="flex gap-1 text-[#FFB84D]" aria-hidden="true">
                  {Array.from({ length: 5 }).map((_, starIndex) => (
                    <span key={starIndex}>★</span>
                  ))}
                </div>
              </div>
              <p className="mt-6 font-pangram text-[15px] leading-[25px] text-[#585D6F]">{review.quote}</p>
            </Reveal>
          ))}
        </div>
      </SectionContainer>
    </section>
  );
}
